import { render, staticRenderFns } from "./configuration_agreements_information.vue?vue&type=template&id=d2af44f0"
import script from "./configuration_agreements_information.vue?vue&type=script&lang=js"
export * from "./configuration_agreements_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports